import Vue from 'vue';
import { DateTime } from 'luxon';

const dateFrom = (data: Date) => {
  if (!data) return '';
  return DateTime.fromISO(new Date(data).toISOString()).toRelative();
};

const dateFormat = (data: Date, formato = 'dd/MM/yyyy') => {
  if (!data) return '';

  const dt = DateTime.fromISO(new Date(data).toISOString());
  return dt.toFormat(formato);
};

const hourFormat = (data: Date) => {
  if (!data) return '';

  const dt = DateTime.fromISO(new Date(data).toISOString());
  return dt.toLocaleString(DateTime.TIME_24_WITH_SECONDS);
};

const dateHourFormat = (data: Date, formato = 'dd/MM/yyyy' ) => {
  if (!data) return '';

  const dt = DateTime.fromISO(new Date(data).toISOString());
  return dt.toFormat(formato) +' às '+ dt.toLocaleString(DateTime.TIME_24_SIMPLE);
};


Vue.filter('dateFrom', dateFrom);
Vue.filter('dateFormat', dateFormat);
Vue.filter('hourFormat', hourFormat);
Vue.filter('dateHourFormat', dateHourFormat);
